define(['jquery', 'c21/maps/TooltipManager'], function ($, TooltipManager) {
   "use strict";

   return function (map) {
      var self = this,

         m_iPinHeight = 60,
         m_iTooltipPadding = 20,
         m_iYOffset = -m_iPinHeight - m_iTooltipPadding,

         m_map = map,
         m_jHoverTemplate = $("<div class='hoverOverlay officeSummaryHoverOverlay'><div class='contentTip'></div></div>"),
         m_jClickTemplate = $("<div class='clickOverlay officeSearchMapOverlay officeSummaryClickOverlay'><div class='contentTip'></div></div>"),
         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            clickTemplate: m_jClickTemplate,
            initClickTooltip: function (jTemplate, pinData) {
               m_jClickTemplate.find(".mapToolTipClose").click(m_tooltipManager.hideClickTooltip);
            },
            getClickHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strPid = pinData.getId(),
                     strId = "#officeSummaryClickOverlay_" + strPid,
                     strHtml = $(strId).html();

                  dfd.resolve(strHtml);
               }).promise();
            },
            getHoverHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strPid = pinData.getId(),
                     strId = "#officeSummaryHoverOverlay_" + strPid,
                     strHtml = $(strId).html();

                  dfd.resolve(strHtml);
               }).promise();
            },
            hoverOffset: {
               x: 0,
               y: m_iYOffset,
               tip: 6
            },
            clickOffset: {
               x: 0,
               y: m_iYOffset,
               tip: 5
            }
         }),
         initialize = function () {};

      self.showClickTooltip = m_tooltipManager.showClickTooltip;
      self.showHoverTooltip = m_tooltipManager.showHoverTooltip;
      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.hideTooltipByPinData = m_tooltipManager.hideTooltipByPinData;
      self.clear = m_tooltipManager.clear;

      initialize();
   };
});
